import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {selectiDB, selectVersion} from "../features/counter/counterSlice";
import {additionalResourceItems, fetchContentForLinks} from "../components/Guideline/getResourceItems";

const useGuidelineMenus = (glObj) => {
  const ccmsversion = useSelector(selectVersion);
  const iDB = useSelector(selectiDB);
  const [resources, setResources] = useState([]);

  useEffect(() => {
    if (!glObj?.glPage) return;
    fetchContentForLinks(glObj, iDB, ccmsversion).then(value => {
      const items = additionalResourceItems(glObj, value.whatsNew, value.doi, ccmsversion);
      setResources(items);
    });
  }, [glObj?.glPage, ccmsversion, iDB]);

  return {resources}
}

export default useGuidelineMenus;
